<template>
  <v-menu
    ref="dialog"
    v-model="modal"
    :close-on-click="true"
    :close-on-content-click="false"
    :return-value.sync="internalValue"
    max-width="290px"
    min-width="290px"
    transition="scale-transition"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="displayDate"
        :label="title"
        v-bind="attrs"
        style="width: 180px;margin: 2px"
        outlined
        :clearable="false"
        readonly
        dense
        hide-details
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="internalValue"
      :type="pickerType"
      scrollable
      locale="kor"
    />
  </v-menu>
</template>

<script>
import {cloneDeep} from "lodash";

export default {
  name: "CustomDatePicker",
  props: {
    value: {
      type: Object,
      default: undefined,
    },
    title: {
      type: String,
      default: '날짜 선택',
    },
    isEnd: {
      type: Boolean,
      default: false,
    },
    pickerType: {
      type: String,
      default: 'date',
    },
  },
  data() {
    return {
      internalValue: undefined,
      menu: false,
      modal: false,
      test: undefined,
    }
  },
  computed: {
    displayDate() {
      if (!this.value) {
        return undefined
      }
      let forMatter

      switch (this.pickerType) {
        case 'month':
          forMatter = 'yyyy-MM'
          break
        case 'year':
          forMatter = 'yyyy'
          break
        default:
          forMatter = 'yyyy-MM-dd'
          break
      }

      return this.value.toFormat(forMatter)
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(newVal) {
        const tempValue = cloneDeep(newVal)
        this.internalValue = tempValue?.toISODate() || undefined
      }
    },
    internalValue(newValue) {
      this.$refs.dialog.save(newValue)
      const parseDate = this.$parseDate(newValue)
      const targetType = this.pickerType === 'date' ? 'day' : this.pickerType
      let dateValue = this.isEnd ? parseDate.endOf(targetType) : parseDate.startOf(targetType)
      this.$emit('input', dateValue)
      this.$emit('update:selected')
    }
  },


}
</script>

<style scoped>

</style>